/* eslint-disable */
import React, {useState} from 'react';
import {useNavigate} from 'react-router-dom';
import 'contents/assets/scss/page/mypage.scss';
import 'contents/assets/scss/page/student.scss';
import Tab from '../../component/Inc/Tab';
import Paging from '../../component/Inc/Paging';
import PopAssignment from './_PopAssignment';
function StudentList() {
  const navigate = useNavigate();
  const [tabIdx, setTabIdx] = useState(0);
  const [modalAssignmentOpen, setModalAssignmentOpen] = useState(false); //배정보고서
  const tab = [
    {title: '전체', value: 0},
    {title: '배정대기', value: 1},
    {title: '준비', value: 2},
    {title: '첫수업', value: 3},
    {title: '진행', value: 4},
    {title: '인계', value: 5},
    {title: '중단', value: 7},
    {title: '종료', value: 8},
    {title: '내 학생', value: 9, type: 'red'}
  ];

  return (
    <main className="com_container com_students">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu1_5">학생 목록</h2>
          <div className="com_btn_wrap">
            <button className="com_btn orange s btn_plus">수업 등록 요청</button>
            <button className="com_btn orange s btn_plus">학생 등록</button>
          </div>
        </section>
        <section className="com_pg_container">
          {/* 수업정보 */}
          <section className="box">
            <div className="com_board_list__top">
              <div className="board_select">
                <select className="select">
                  <option value="이지수능 (본사)">이지수능 (본사)</option>
                </select>
                <Tab data={tab} tab={tabIdx} setTab={setTabIdx} />
              </div>
            </div>
            <hr className="com_divider" />
            <div className="com_board_list__top">
              <div className="board_select">
                <div className="check">
                  <input type="radio" name="rdo" id="rdo01" className="com_chk circle" />
                  <label htmlFor="rdo01">전체</label>
                  <input type="radio" name="rdo" id="rdo02" className="com_chk circle" />
                  <label htmlFor="rdo02">국어</label>
                  <input type="radio" name="rdo" id="rdo03" className="com_chk circle" />
                  <label htmlFor="rdo03">영어</label>
                  <input type="radio" name="rdo" id="rdo04" className="com_chk circle" />
                  <label htmlFor="rdo04">수학</label>
                  <input type="radio" name="rdo" id="rdo05" className="com_chk circle" />
                  <label htmlFor="rdo05">과탐</label>
                  <input type="radio" name="rdo" id="rdo06" className="com_chk circle" />
                  <label htmlFor="rdo06">사탐</label>
                  <input type="radio" name="rdo" id="rdo07" className="com_chk circle" />
                  <label htmlFor="rdo07">수시</label>
                  <input type="radio" name="rdo" id="rdo08" className="com_chk circle" />
                  <label htmlFor="rdo08">논술</label>
                </div>
              </div>
              <section className="com_board_search end">
                <article className="search">
                  <input type="search" placeholder="학생명 검색" className="input s type_search" />
                  <button className="com_btn gray ws s icon_search"></button>
                </article>
              </section>
            </div>
            <hr className="com_divider" />
            <div className="com_board_list__top">
              <section className="com_board_search end">
                <div className="date_wrap">
                  <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                  <span className="divider"> ~ </span>
                  <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                </div>
                <article className="search">
                  <input type="search" placeholder="검색할 내용을 입력해 주세요." className="input s type_search" />
                  <button className="com_btn gray ws s icon_search"></button>
                </article>
              </section>
            </div>
            {tabIdx === 0 ? (
              <table className="com_board_list">
                <colgroup>
                  <col width="5%" />
                  <col width="5%" />
                  <col width="5%" />
                  <col width="5%" />
                  <col width="5%" />
                  <col width="5%" />
                  <col width="5%" />
                  <col width="8%" />
                  <col width="5%" />
                  <col width="5%" />
                  <col width="5%" />
                  <col width="5%" />
                </colgroup>
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>학생명</th>
                    <th>과목</th>
                    <th>상태</th>
                    <th>학교</th>
                    <th>학년</th>
                    <th>지역</th>
                    <th>최근 수업일</th>
                    <th>회차/ T/수업시간</th>
                    <th>진행 회차</th>
                    <th>교사</th>
                    <th>담임</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>11</td>
                    <td>
                      <button onClick={() => navigate('/Student/Detail/Info')} className="name btn_link">
                        김길동111
                      </button>
                    </td>
                    <td>수학</td>
                    <td className="td_red">첫수업</td>
                    <td>서울고</td>
                    <td>고3</td>
                    <td>강남</td>
                    <td className="td_date">2022.08.25 12:30</td>
                    <td>16 / 2T</td>
                    <td>10</td>
                    <td>
                      <button onClick={() => navigate('/Student/Detail/Info')} className="name btn_link">
                        김선생120
                      </button>
                    </td>
                    <td>
                      <button onClick={() => navigate('/Student/Detail/Info')} className="name btn_link">
                        김담임120
                      </button>
                    </td>
                  </tr>
                  {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i, idx) => {
                    return (
                      <tr key={idx}>
                        <td>{10 - idx}</td>
                        <td>
                          <button className="name btn_link">김길동111</button>
                        </td>
                        <td>수학</td>
                        <td className="td_point">진행</td>
                        <td>서울고</td>
                        <td>중 3이하</td>
                        <td>강남</td>
                        <td className="td_date">2022.08.25 12:30</td>
                        <td>16 / 2T</td>
                        <td>10</td>
                        <td>
                          <button className="name btn_link">김선생120</button>
                        </td>
                        <td>
                          <button className="name btn_link">김담임120</button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            ) : (
              <table className="com_board_list">
                <colgroup>
                  <col width="5%" />
                  <col width="8%" />
                  <col width="8%" />
                  <col width="8%" />
                  <col width="8%" />
                  <col width="8%" />
                  <col width="8%" />
                  <col width="8%" />
                  <col width="8%" />
                </colgroup>
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>학생명</th>
                    <th>과목</th>
                    <th>상태</th>
                    <th>학교</th>
                    <th>지역</th>
                    <th>과목</th>
                    <th>
                      <button className="arrow active" />
                      미배정 시간
                    </th>
                    <th>담임</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="selected">
                    <td>11</td>
                    <td>
                      <button onClick={() => navigate('/Student/Detail/Info')} className="name btn_link">
                        김길동111
                      </button>
                    </td>
                    <td>수학</td>
                    <td className="td_red">첫수업</td>
                    <td>서울고</td>
                    <td>강남</td>
                    <td>국어</td>
                    <td className="td_red">48</td>
                    <td>
                      <button onClick={() => navigate('/Student/Detail/Info')} className="name btn_link">
                        김담임120
                      </button>
                    </td>
                  </tr>
                  {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i, idx) => {
                    return (
                      <tr key={idx}>
                        <td>{10 - idx}</td>
                        <td>
                          <button className="name btn_link">김길동111</button>
                        </td>
                        <td>수학</td>
                        <td className="td_point">진행</td>
                        <td>서울고</td>
                        <td>강남</td>
                        <td>국어</td>
                        <td>10</td>
                        <td>
                          <button className="name btn_link">김선생120</button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            )}
            <Paging />
          </section>
          {/* 수업 히스토리 */}
          <section className="box">
            <div className="detail_tit dot">수업 히스토리</div>
            <ul className="com_board_box">
              <li className="board_item">
                <div className="info">
                  <span className="tit">학생명</span>
                  <span className="cont">
                    <button className="name btn_link">홍길동103 </button>
                    <span className="desc"> (고3ㆍ경기고등학교ㆍ본사) </span>
                  </span>
                </div>
                <div className="info">
                  <span className="tit">전화번호</span>
                  <span className="cont">010-2023-3030</span>
                </div>
                <div className="info">
                  <span className="tit">부모폰</span>
                  <span className="cont">
                    부)010-2023-3030 <span className="dot" />
                    모)010-3030-3333
                  </span>
                </div>
                <div className="info">
                  <span className="tit">홍보키</span>
                  <span className="cont">
                    <span className="btn_link">김홍보320</span>
                  </span>
                </div>
                <div className="info">
                  <span className="tit">담임</span>
                  <span className="cont">
                    <span className="btn_link">김담임320</span>
                  </span>
                </div>
                <div className="info">
                  <span className="tit">영업</span>
                  <span className="cont">담홍보</span>
                </div>
                <hr className="com_divider" />
                <div className="info">
                  <span className="tit">수업장소</span>
                  <span className="cont">경기도 수원시 팔달구 팔달로1234 모여라 빌딩 203호</span>
                </div>
              </li>
              <li className="board_item">
                <div className="info">
                  <span className="tit">수업 과목</span>
                  <span className="cont com_blue_txt">과탐 (사회문화,경제,밥과정서)</span>
                </div>
                <div className="info">
                  <span className="tit">교사</span>
                  <span className="cont">
                    <span className="com_cancel_txt">김교사123</span> → 최교사405
                  </span>
                </div>
                <div className="info">
                  <span className="tit">교사 시수</span>
                  <span className="cont">45,000</span>
                </div>
                <div className="info">
                  <span className="tit">시수 변경</span>
                  <span className="cont">
                    원거리 시수 + 3,000{' '}
                    <button onClick={() => setModalAssignmentOpen(true)} className="btn_report">
                      원거리 배정 보고서
                    </button>
                  </span>
                </div>
                <hr className="com_divider" />
                <div className="info">
                  <span className="tit">회차 / 타임</span>
                  <span className="cont">16회 / 2T</span>
                </div>
                <div className="info">
                  <span className="tit">완성수업</span>
                  <span className="cont"></span>
                </div>
                <div className="info">
                  <span className="tit">수업 시간 / 방법</span>
                  <span className="cont">30분 / 대면</span>
                </div>
                <div className="info">
                  <span className="tit">첫수업일</span>
                  <span className="cont">2023. 05. 12 12:30</span>
                </div>
                <div className="info">
                  <span className="tit">수업일</span>
                  <span className="cont">수, 목 12 :30</span>
                </div>
                <div className="info">
                  <span className="tit">수업 시간 / 방법</span>
                  <span className="cont">30분 / 대면</span>
                </div>
                <div className="info">
                  <span className="tit">비교수업</span>
                  <span className="cont">N</span>
                </div>
                <div className="info">
                  <span className="tit">동시수업</span>
                  <span className="cont">김학생103, 최학생123, 최학생105</span>
                </div>
                <hr className="com_divider" />
                <div className="info">
                  <span className="tit">DC코드 / 할인금액</span>
                  <span className="cont">형제할인 5%ㆍ45,000</span>
                </div>
                <div className="info">
                  <span className="tit">1회수업료</span>
                  <span className="cont">45,000</span>
                </div>
                <div className="info">
                  <span className="tit">수업료</span>
                  <span className="cont com_blue_txt">2,495,000</span>
                </div>
                <hr className="com_divider" />
                <div className="info">
                  <span className="tit">메모</span>
                  <span className="cont">부모님이 홍길동 교사를 원하세요.</span>
                </div>
              </li>
              <li className="board_item">
                <div className="info">
                  <span className="tit">영업 정보</span>
                  <span className="cont">홍보ㆍ김담임103</span>
                </div>
                <hr className="com_divider" />
                <div className="info">
                  <span className="tit">수업변경</span>
                  <p className="cont">
                    <span className="date">2022, 05, 10</span> : 타임추가ㆍ 홍길동103 <br />
                    <span className="date">2021, 06, 12</span> : 첫 수업전 취소 <br />
                    <span className="date">2020, 04, 24</span> : 인계 ㆍ최교사405
                  </p>
                </div>
              </li>
              <li className="board_item">
                <div className="info total">
                  <span className="tit">총입금액</span>
                  <span className="cont">95,000</span>
                  <span className="bar" />
                  <span className="tit">총입금회차</span>
                  <span className="cont">45,5</span>
                  <span className="bar" />
                  <span className="tit com_red_txt">미수금</span>
                  <span className="cont com_red_txt">55,000</span>
                </div>
                <hr className="com_divider" />
                <div className="info">
                  <div className="cont date">
                    <p>2023,05,10ㆍ수학ㆍ5회ㆍ750,000ㆍ홍길동ㆍ카드ㆍ하나카드 (1132-3221-32131)</p>
                    <p>2023,05,10ㆍ수학ㆍ5회ㆍ750,000ㆍ홍길동ㆍ가상계좌ㆍ1132-3221-31231</p>
                    <p>2023,05,10ㆍ수학ㆍ5회ㆍ750,000ㆍ홍길동ㆍ현금</p>
                  </div>
                </div>
              </li>
            </ul>
            <div className="com_btn_wrap center bottom">
              <button className="com_btn orange s">배정 변경</button>
              <button className="com_btn orange s">결제 변경</button>
              <button className="com_btn orange s">수업 변경</button>
            </div>
          </section>
        </section>
      </div>{' '}
      <PopAssignment open={modalAssignmentOpen} close={() => setModalAssignmentOpen(false)} />
    </main>
  );
}

export default StudentList;
